<template>
    <div style="display:flex; flex-direction: row; height: 100%;" v-if="canViewRealtime">
      <realtime-roster :style="rosterStyle"/>
      <realtime-view style="flex-grow: 1;"/>
    </div>
</template>

<script>
import RealtimeRoster from './RealtimeRoster'
import RealtimeView from './RealtimeView'
import { mapGetters } from 'vuex'

export default {
  name: 'RealtimeContainer',
  components: {
    RealtimeRoster,
    RealtimeView,
  },
  data () {
    return {
      showRoster: true,
    }
  },
  methods: {
    toggleRoster () {
      this.showRoster = !this.showRoster
    },
  },
  computed: {
    ...mapGetters({
      preferences: 'preferences',
    }),
    canViewRealtime () {
      return this.preferences.has_realtime_credentials
    },
    rosterStyle () {
      if (this.showRoster) {
        return 'width: 25vw;'
      } else {
        return 'display: none;'
      }
    },
  },
}
</script>

<style>

</style>
